<template>
  <div>
    <HospitalDetails></HospitalDetails>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const HospitalDetails = defineAsyncComponent(() =>
  import("@/components/hospitals/HospitalDetails")
);
export default {
  components: {
    HospitalDetails,
  },
};
</script>
